
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.05 23c1.064-.045 3.146.052 4.06-1.861.901-1.884.71-6.026.629-8.175-.21-2.548-.148-7.732.725-9.372C7.382 1.867 8.252 1.136 10.04 1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1.05 23c1.064.045 3.145-.052 4.06 1.861.901 1.884.71 6.026.629 8.175-.21 2.548-.148 7.732.725 9.372.918 1.725 1.788 2.456 3.577 2.592","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"14.541","y":"2.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('circle',{attrs:{"cx":"22.041","cy":"19","r":"1","transform":"rotate(90 22.04 19)","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"22.041","cy":"23","r":"1","transform":"rotate(90 22.04 23)","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"22.041","cy":"27","r":"1","transform":"rotate(90 22.04 27)","fill":"currentColor"}}),_c('rect',{attrs:{"x":"14.541","y":"32.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    